<script>
    import {PASSPORT_STATUS} from "../lib/constants";
    import AppIcon from "../components/icons/AppIcon.svelte";

    export let status = null;
    export let list = [];

    let collapsed = true;
    let title = '';

    if (status == PASSPORT_STATUS.ASSIGNED) {
        title = "Ανατεθειμένα";
    } else if (status == PASSPORT_STATUS.RETURNED) {
        title = "Επιστραμμένα";
    } else if (status == PASSPORT_STATUS.DESTROYED) {
        title = "Κατεστραμμένα";
    }
</script>
{#if list && list.length}
    <div class="mb-2">
        <div class="legend d-flex align-items-center justify-content-between pointer px-2 py-1"
             on:click={ () => collapsed = !collapsed}>
            { title } ({ list.length })
            <div>
                <AppIcon icon="{ collapsed ? 'chevron-down' : 'chevron-left' }" strokeWidth="2"/>
            </div>
        </div>
        {#if !collapsed}
            <table class="table table-list table-sm mb-2">
                <tbody>
                {#if list.length}
                    {#each list as item}
                        <tr>
                            <td class="ps-1">{ item.passport }</td>
                            <td class="pe-1">{ item.vat }</td>
                        </tr>
                    {/each}
                {/if}
                </tbody>
            </table>
        {/if}
    </div>
{/if}